import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'

import IconCheck from '../../../../../assets/icons/IconCheck'
import IconPhone from '../../../../../assets/icons/IconPhone'
import useTranslations from '../../../../../i18n/useTranslations'

import Schedule from './Schedule'

const InputRadio = ({
  name,
  label,
  fullAddress,
  distance,
  extraInfo,
  value = '',
  checked,
  onClick,
}) => {
  const t = useTranslations()
  const isComplexRadio = fullAddress || distance
  const RadioLabelGroupWrapper = isComplexRadio ? 'span' : Fragment

  const [scrollTop, setScrollTop] = useState(0)
  const [scrollBottom, setScrollBottom] = useState(0)

  const handleScroll = event => {
    setScrollTop(event.currentTarget.scrollTop > 0)
    setScrollBottom(
      event.currentTarget.scrollHeight - event.currentTarget.scrollTop ===
        event.currentTarget.clientHeight,
    )
  }

  return (
    <div
      className={`radio-wrapper${
        checked && isComplexRadio
          ? ' is-complexRadio is-checked'
          : isComplexRadio
          ? ' is-complexRadio'
          : ''
      }`}
    >
      <label className="radio-content">
        <input
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onClick={onClick}
          className="radio"
        />
        <span className="radio-iconWrapper">
          <IconCheck />
        </span>

        <RadioLabelGroupWrapper className="radio-labelGroupWrapper">
          <span className="radio-labelText">{label}</span>
          {fullAddress ? (
            <span className="radio-sublabelText font-label">{fullAddress}</span>
          ) : null}
        </RadioLabelGroupWrapper>

        {distance ? (
          <span className="radio-distance font-label">{distance} km</span>
        ) : null}
      </label>
      {isComplexRadio && checked ? (
        <div
          className={`radio-extraInfo ${scrollTop ? 'scrolledTop' : ''} ${
            scrollBottom ? 'scrolledBottom' : ''
          }`}
          onScroll={handleScroll}
        >
          <div className="radio-extraInfoRow">
            <IconPhone />
            <div className="radio-extraInfoDataWrapper">
              <p className="radio-extraInfoLabel font-label">
                {t('noun:phone')}
              </p>
              <p className="radio-extraInfoData font-h4">{extraInfo.phone}</p>
            </div>
          </div>
          <Schedule schedule={extraInfo.schedule} />
        </div>
      ) : null}
    </div>
  )
}

InputRadio.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  fullAddress: PropTypes.string,
  distance: PropTypes.number,
  extraInfo: PropTypes.shape({
    schedule: PropTypes.string,
    phone: PropTypes.string,
  }),
  value: PropTypes.string,
  checked: PropTypes.bool,
  selected: PropTypes.shape({
    address: PropTypes.string,
    lat: PropTypes.number,
    lng: PropTypes.number,
    name: PropTypes.string,
    phoneNumber: PropTypes.string,
    schedule: PropTypes.string,
    detailedAddress: PropTypes.shape({
      address: PropTypes.string,
      address_2: PropTypes.string,
      country_code: PropTypes.string,
      gps_latitude: PropTypes.number,
      gps_longitude: PropTypes.number,
      postal_code: PropTypes.string,
    }),
  }),
  onClick: PropTypes.func,
}

const RadioGroup = ({ name, options, extraClass, selected }) => {
  return (
    <div className={`radioGroup${extraClass ? ' ' + extraClass : ''}`}>
      {options.map(option => (
        <InputRadio
          key={name}
          name={name}
          label={option.label}
          value={option.value}
          fullAddress={option.fullAddress}
          distance={option.distance}
          extraInfo={option.extraInfo}
          checked={option.value === selected?.address}
          onClick={option.onClick}
        />
      ))}
    </div>
  )
}

RadioGroup.propTypes = {
  name: PropTypes.string,
  options: PropTypes.array,
  extraClass: PropTypes.string,
  selected: PropTypes.string,
}

export default RadioGroup
